import { defineComponent as _defineComponent } from 'vue'
import type { Game } from '@/models/Game'
import { computed, reactive, onMounted } from 'vue'
import type { PropType } from 'vue'
import useValidate from '@vuelidate/core'
import { required, helpers, minLength } from '@vuelidate/validators'

// eslint-disable-next-line @typescript-eslint/no-unused-vars

export default /*#__PURE__*/_defineComponent({
  __name: 'TicketsGameInputs',
  props: {
  game: {
    required: true,
    type: Object as PropType<Game>
  },
},
  emits: ['save', 'cancel'],
  setup(__props, { expose, emit }) {
  expose();

const props = __props




// eslint-disable-next-line @typescript-eslint/no-unused-vars
let editGame = reactive<Game>(props.game.copy())
const requiredMsg = 'Das Feld darf nicht leer sein'

const rules = computed(() => {
  return {
    summary: { 
      required: helpers.withMessage(requiredMsg, required),
      minLength: helpers.withMessage('Mind. 7 Zeichen erforderlich', minLength(7))
    },
    dtstart: {
      required: helpers.withMessage(requiredMsg, required)
    },
    dtend: {
      required: helpers.withMessage(requiredMsg, required)
    },
    location: {
      required: helpers.withMessage(requiredMsg, required),
      minLength: helpers.withMessage('Mind. 7 Zeichen erforderlich', minLength(7))
    }
  }
})

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const v$ = useValidate(rules, props.game, { $autoDirty: true })

// eslint-disable-next-line @typescript-eslint/no-unused-vars


// eslint-disable-next-line @typescript-eslint/no-unused-vars
const save = async () => {
  if (await v$.value.$validate()) {
    emit('save', editGame)
  }
}

onMounted(() => {
  //v$.value.$validate()
})


const __returned__ = { props, editGame, requiredMsg, rules, v$, emit, save, computed, reactive, onMounted, useValidate, required, helpers, minLength }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})